import { createResourceApi } from 'resources/ResourceApi';
import { CancelReasonApiItem } from 'features/CancelReason/types';

export const apiKey = 'cancel_reasons';

export default createResourceApi<CancelReasonApiItem>(apiKey);
